/* src/app/shared/components/form-controls/ag-opening-hours/ag-opening-hours.component.scss */
.row {
  font-size: 14px;
  display: flex;
  align-items: center;
  min-height: 44px;
  margin: 8px 0;
}
.row .daycolumn {
  width: 85px;
  height: 100%;
  align-self: center;
}
.row .duration {
  display: flex;
}
.row .duration.has-errors {
  border: solid 2px #d7263c;
  border-radius: 8px;
  padding: 7px 11px;
}
.row .duration .dash {
  margin: auto;
  padding: 0 8px;
}
.row .buttons {
  display: flex;
  padding: 0 8px;
}
.row .buttons .circle {
  display: flex;
  justify-content: center;
  cursor: pointer;
  width: 29px;
  height: 29px;
  border-radius: 15px;
  box-shadow: 0 1px 3px 0 rgba(140, 140, 140, 0.3);
  margin-right: 8px;
}
.row .buttons .circle.purple {
  background-color: #61566e;
}
.row .buttons .circle.green {
  background-color: #578a6b;
}
.row .buttons .icon {
  width: 16px;
  height: 16px;
  align-self: center;
}
/*# sourceMappingURL=ag-opening-hours.component.css.map */
